"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.themes = void 0;
const LightTheme_1 = __importDefault(require("./LightTheme"));
const DarkTheme_1 = __importDefault(require("./DarkTheme"));
/**
 * Themes also can be loaded with React.lazy( () => import("..."))
 */
exports.themes = {
    "light": {
        id: 'light',
        displayName: 'Light',
        component: LightTheme_1.default,
    },
    "dark": {
        id: 'dark',
        displayName: 'Dark',
        component: DarkTheme_1.default,
    },
};
